import React from 'react';
import { Facebook, Instagram, Linkedin, MapPin, Mail, Phone } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-300 py-12 border-t border-gray-800" data-id="element-63">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-64">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-65">
          {/* Company Info */}
          <div data-id="element-66">
            <h3 className="text-white text-lg font-bold mb-4" data-id="element-67">
              Desert Sage Seminars
            </h3>
            <div className="space-y-3 text-sm" data-id="element-68">
              <p className="flex items-start" data-id="element-69">
                <MapPin className="w-5 h-5 mr-3 text-brand-purple-400 flex-shrink-0" data-id="element-70" />
                <span data-id="element-71">Phoenix, Arizona</span>
              </p>
              <p className="flex items-center" data-id="element-72">
                <Phone className="w-5 h-5 mr-3 text-brand-purple-400 flex-shrink-0" data-id="element-73" />
                <a href="tel:6023776207" className="hover:text-white" data-id="element-74">
                  602-377-6207
                </a>
              </p>
              <p className="flex items-center" data-id="element-75">
                <Mail className="w-5 h-5 mr-3 text-brand-purple-400 flex-shrink-0" data-id="element-76" />
                <a href="mailto:CustomerService@DesertSageSeminars.com" className="hover:text-white" data-id="element-77">
                  CustomerService@DesertSageSeminars.com
                </a>
              </p>
            </div>
            <div className="mt-6 flex space-x-4" data-id="element-78">
              <a href="https://www.facebook.com/DesertSageSeminars/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="Facebook" data-id="element-79">
                <Facebook className="w-5 h-5" data-id="element-80" />
              </a>
              <a href="https://instagram.com/desertsageseminars/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="Instagram" data-id="element-81">
                <Instagram className="w-5 h-5" data-id="element-82" />
              </a>
              <a href="https://www.linkedin.com/company/desert-sage-seminars" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="LinkedIn" data-id="element-83">
                <Linkedin className="w-5 h-5" data-id="element-84" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-85">
            <h3 className="text-white text-lg font-bold mb-4" data-id="element-86">Quick Links</h3>
            <ul className="space-y-2 text-sm" data-id="element-87">
              <li data-id="element-88">
                <a href="#" className="hover:text-brand-purple-400 transition-colors" data-id="element-89">
                  On-Demand Classes
                </a>
              </li>
              <li data-id="element-90">
                <a href="#" className="hover:text-brand-purple-400 transition-colors" data-id="element-91">
                  Zoom Classes
                </a>
              </li>
              <li data-id="element-92">
                <a href="#" className="hover:text-brand-purple-400 transition-colors" data-id="element-93">
                  In-Person Classes
                </a>
              </li>
              <li data-id="element-94">
                <a href="#" className="hover:text-brand-purple-400 transition-colors" data-id="element-95">
                  Class Schedule
                </a>
              </li>
              <li data-id="element-96">
                <a href="#" className="hover:text-brand-purple-400 transition-colors" data-id="element-97">
                  My Account
                </a>
              </li>
              <li data-id="element-98">
                <a href="#" className="hover:text-brand-purple-400 transition-colors" data-id="element-99">
                  Contact Support
                </a>
              </li>
            </ul>
          </div>

          {/* Certifications */}
          <div data-id="element-100">
            <h3 className="text-white text-lg font-bold mb-4" data-id="element-101">Accreditation</h3>
            <div className="space-y-4 text-sm" data-id="element-102">
              <div className="p-4 bg-gray-800 rounded-lg border border-gray-700" data-id="element-103">
                <p className="font-semibold text-white mb-1" data-id="element-104">
                  ADRE School #S06-0002
                </p>
                <p className="text-xs text-gray-400" data-id="element-105">
                  Approved by the Arizona Department of Real Estate
                </p>
              </div>
              <div className="p-4 bg-gray-800 rounded-lg border border-gray-700" data-id="element-106">
                <p className="font-semibold text-white mb-1" data-id="element-107">REEA Member</p>
                <p className="text-xs text-gray-400" data-id="element-108">
                  Real Estate Educators Association
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500" data-id="element-109">
          <p data-id="element-110">
            &copy; {new Date().getFullYear()} Desert Sage Seminars. All rights
            reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-111">
            <a href="#" className="hover:text-white" data-id="element-112">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white" data-id="element-113">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}